import "./EditPartners.scss";
import { useState, useEffect } from "react";
import {
  InputAdornment,
  TextField,
  useMediaQuery,
  Modal,
  Box,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { EditPartnersColumns } from "../../SourceData";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/ClearOutlined";
import AcceptIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MessageModals from "../../components/MessageModals/MessageModals";
import WhatsApp from "./../../assets/whats-icon.svg";
import ViewIcon from "./../../assets/show-user.svg";
import IdImg from "./../../assets/id-img.png";
import api from "../../utils/api";
import { Link } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";

const EditPartners = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [query, setQuery] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [currentView, setCurrentView] = useState("");
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const { hasPermission } = usePermissions();

  // New state for ID image modal
  const [openIdModal, setOpenIdModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  useEffect(() => {
    getData();
  }, [query, page, pageSize]);

  const getData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: pageSize,
      });

      if (query) {
        params.append("search", query);
      }

      const res = await api.get(
        `/document-vendor-requests?${params.toString()}`
      );
      setVendors(res.data.data);
      // Fix: Use the total count from API response, not the current page data length
      setTotalRows(res.data.total);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMessage = (view, vendorId) => {
    setSelectedVendorId(vendorId);
    setCurrentView(view);
    setOpenMessage(true);
  };

  // Handle pagination changes
  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  const handleModalClose = () => {
    setOpenMessage(false);
    setSelectedVendorId(null);
  };

  // Handler for opening the ID images modal
  const handleOpenIdModal = (vendor) => {
    setSelectedVendor(vendor);
    setOpenIdModal(true);
  };

  // Handler for closing the ID images modal
  const handleCloseIdModal = () => {
    setOpenIdModal(false);
    setSelectedVendor(null);
  };

  const idModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "95%" : "90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 0,
    borderRadius: "8px",
    maxHeight: "90vh",
    overflow: "auto",
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 240,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            {hasPermission(41) && (
              <>
                <div
                  className="icon-container"
                  style={{ backgroundColor: "#E63050", color: "white" }}
                  onClick={() => handleMessage("reject", params.row.id)}
                >
                  <CancelIcon className="icon" style={{ color: "white" }} />
                </div>

                <div
                  className="icon-container"
                  style={{ backgroundColor: "#28B446" }}
                  onClick={() => handleMessage("accept", params.row.id)}
                >
                  <AcceptIcon className="icon" style={{ color: "white" }} />
                </div>
              </>
            )}

            <Link
              className="cell-btn"
              to={`https://wa.me/${params?.row?.whatsapp}`}
              target="_blank"
            >
              <img src={WhatsApp} alt="" />
            </Link>

            {/* Modified to open modal instead of navigating */}
            {hasPermission(40) && (
              <div
                className="cell-btn"
                onClick={() => handleOpenIdModal(params.row)}
                style={{ cursor: "pointer" }}
              >
                <img src={ViewIcon} alt="" />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  // EditPartnerPapers component integrated as a modal content
  const EditPartnerPapersContent = () => {
    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          padding: "24px",
          fontFamily: "'Cairo', 'Roboto', sans-serif",
          maxWidth: "900px",
          margin: "0 auto",
          color: "#333",
          direction: "rtl",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "15px",
            left: "15px",
            cursor: "pointer",
            zIndex: 10,
            backgroundColor: "#f5f5f5",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
          }}
          onClick={handleCloseIdModal}
        >
          <CloseIcon style={{ color: "#555", fontSize: "20px" }} />
        </div>

        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              fontWeight: "700",
              marginBottom: "20px",
              color: "#2c3e50",
              borderBottom: "2px solid #f1f1f1",
              paddingBottom: "8px",
            }}
          >
            بطاقة الهوية - الوجه/الظهر
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              marginTop: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#666",
                  backgroundColor: "#f8f9fa",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  textAlign: "center",
                }}
              >
                الصورة الحالية
              </span>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "8px",
                    padding: "5px",
                    backgroundColor: "#fafafa",
                    height: "180px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={selectedVendor?.id_front_image || IdImg}
                    alt="صورة الوجه"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "8px",
                    padding: "5px",
                    backgroundColor: "#fafafa",
                    height: "180px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={selectedVendor?.id_back_image || IdImg}
                    alt="صورة الظهر"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#666",
                  backgroundColor: "#f8f9fa",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  textAlign: "center",
                }}
              >
                الصورة الجديدة
              </span>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "8px",
                    padding: "5px",
                    backgroundColor: "#fafafa",
                    height: "180px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {selectedVendor?.new_id_front_image ? (
                    <img
                      src={
                        selectedVendor.new_id_front_image !==
                        "https://sahmaraby.com/public/storage"
                          ? selectedVendor.new_id_front_image
                          : IdImg
                      }
                      alt="صورة الوجه الجديدة"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <img
                      src={IdImg}
                      alt="صورة الوجه الجديدة"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "8px",
                    padding: "5px",
                    backgroundColor: "#fafafa",
                    height: "180px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                  }}
                >
                  {selectedVendor?.new_id_back_image ? (
                    <img
                      src={
                        selectedVendor.new_id_back_image !==
                        "https://sahmaraby.com/public/storage"
                          ? selectedVendor.new_id_back_image
                          : IdImg
                      }
                      alt="صورة الظهر الجديدة"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <img
                      src={IdImg}
                      alt="صورة الظهر الجديدة"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="users">
      <div className="special-header">
        <p className="title">طلبات تعديل اوراق المتاجر/المصانع</p>
        <div className="actions-container">
          <div className="search">
            <TextField
              id="outlined-search"
              type="search"
              value={query}
              placeholder="البحث باسم المتجر/ المصنع"
              onChange={(e) => setQuery(e.target.value)}
              sx={{
                width: isMobile ? "100%" : isTablet ? "300px" : "360px",
                borderRadius: "8px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
      </div>

      <div className="container">
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={EditPartnersColumns.concat(actionColumn)}
          rows={vendors.map((row, index) => ({
            ...row,
            index: page * pageSize + index + 1, // Fix: Calculate global index
          }))}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          loading={loading}
          // Pagination props
          paginationMode="server" // Add server-side pagination
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page,
            pageSize,
          }}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows} // Total rows across all pages
          // Ensure rows have unique IDs
          getRowId={(row) => row.id}
        />
      </div>

      <MessageModals
        open={openMessage}
        currentView={currentView}
        onClose={handleModalClose}
        itemId={selectedVendorId}
        onDataChange={getData}
        text="تم تحديث حالة الطلب بنجاح"
        acceptRoute="/action-vendor-requests"
        rejectRoute="/action-vendor-requests"
        acceptData={{
          vendor_id: selectedVendorId,
          active: 1,
        }}
        rejectData={{
          vendor_id: selectedVendorId,
          active: 2,
        }}
        type="product"
      />

      {/* Modal for EditPartnerPapers */}
      <Modal
        open={openIdModal}
        onClose={handleCloseIdModal}
        aria-labelledby="id-papers-modal"
        aria-describedby="modal-to-display-id-papers"
      >
        <Box sx={idModalStyle} dir="rtl">
          <EditPartnerPapersContent />
        </Box>
      </Modal>
    </div>
  );
};

export default EditPartners;
